<template>
  <div class="w-100">
    <app-info-bar :canConnect="true"></app-info-bar>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppFooter from 'components/footer/app-footer'
import AppInfoBar from 'components/app-info-bar'

export default {
  name: 'HomeLayout',
  components: { AppFooter, AppInfoBar }
}
</script>



// WEBPACK FOOTER //
// src/layouts/home/index.vue